import axios from './axios.service'

const method = 'user'

class UserService {
  async index(queryData) {
    try {
      const response = await axios.get(`/${method}`, {
        params: { ...queryData }
      })
      return response.data
    } catch (error) {
      return error
    }
  }

  async show(id) {
    try {
      const response = await axios({
        method: 'get',
        url: `/${method}/${id}`
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async updateStatus(rowClicked, status) {
    try {
      const response = await axios({
        method: 'put',
        url: `/${method}/update/status/${rowClicked.id}`,
        data: {
          status
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async deleteUser(rowClicked) {
    try {
      const response = await axios.delete(`/${method}/${rowClicked.id}`)
      return response
    } catch (error) {
      return error
    }
  }

  async sendWelcomeEmail(email) {
    try {
      const response = await axios({
        method: 'post',
        url: '/sendwelcome',
        data: {
          email
        }
      })
      return response.data
    } catch (error) {
      return error.response
    }
  }

  async getFormOptions() {
    try {
      const response = await axios({
        method: 'get',
        url: `/${method}/create`
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async store(data) {
    try {
      const response = await axios({
        method: 'post',
        url: `/${method}/signin`,
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async update(id, data) {
    try {
      const response = await axios({
        method: 'put',
        url: `/${method}/update/${id}`,
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }
}

export default new UserService()
